import { DateRange, DateRangePicker, LocalizationProvider, SingleInputDateRangeField } from '@mui/x-date-pickers-pro';
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalaliV3';
import { addDays, format } from "date-fns-jalali";
import { BaseSyntheticEvent, useRef, useState } from 'react';
import './App.css';
import Iconmoon from './components/iconmoon';
import './fonts/icomoon/style.css';

function toGregorianDate(date: Date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function getBookingConfig() {
  const host = document.getElementById('booking_host')?.getAttribute('value') ?? 'abbasihotel.crs-booking.com';
  const hotelId = document.getElementById('hotel_id')?.getAttribute('value') ?? '110';
  return { host, hotelId };
}

function AppFa() {
  const [alertDate, setAlertDate] = useState('');
  const [dateValue, setDateValue] = useState<DateRange<Date>>([new Date(), addDays(new Date(), 1)]);
  const [tagmanagerTriger, setTagmanagerTriger] = useState<boolean>(false);
  const [pickerOpen, setPickerOpen] = useState(false);

  const myform = useRef<HTMLFormElement | null>(null);

  function setDateFn(newValue: DateRange<Date>) {
    setDateValue(newValue);
    setAlertDate('');
  }

  const handleSubmit = (event: BaseSyntheticEvent) => {
    event.preventDefault();

    if (!dateValue[0] || !dateValue[1]) {
      setAlertDate('تاریخ ورود و خروج را انتخاب کنید.');
      return;
    }

    const fromDate = toGregorianDate(dateValue[0]);
    const toDate = toGregorianDate(dateValue[1]);
    const { host, hotelId } = getBookingConfig();
    const url = `https://${host}/fa/hotel/find-hotel/${hotelId}?from-date=${fromDate}&to-date=${toDate}`;

    setTagmanagerTriger(true);
    setTimeout(() => {
      window.open(url, '_blank');
    }, 2000);
  };

  return (
    <form method='post' onSubmit={handleSubmit} ref={myform}>
      <div className="flex flex-col md:flex-row py-1 px-5">
        <div className='relative flex flex-col md:flex-row mt-4 md:mt-0 grow'>
          <div className='selectDate absolute top-0 left-0 w-full h-full opacity-0 overflow-hidden pointer-events-none'>
            <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
              <DateRangePicker
                open={pickerOpen}
                onOpen={() => setPickerOpen(true)}
                onClose={() => setPickerOpen(false)}
                disablePast={true}
                slots={{ field: SingleInputDateRangeField }}
                onChange={(newValue) => { setDateFn(newValue) }}
                value={dateValue}
                format='yyyy/MM/dd'
              />
            </LocalizationProvider>
          </div>

          <div className='selectDate md:mr-6 grow'>
            <div className='mb-0 h-[18px]'>
              <span className='uppercase text-xs font-bold'> ورود</span>
            </div>
            <div
              className='border-b border-black flex md:min-w-[180px] items-center py-3 cursor-pointer'
              onClick={() => setPickerOpen(true)}
            >
              <input
                readOnly
                type="text"
                className='outline-none grow !border-none !bg-[transparent] !py-0 pointer-events-none !text-lg text-black'
                value={dateValue[0] ? format(dateValue[0], 'yyyy/MM/dd') : ''}
              />
              <span>
                <Iconmoon name='calendar_today' class='text-xl text-silver'></Iconmoon>
              </span>
            </div>
          </div>

          <div className='selectDate mt-4 md:mt-0 md:mr-6 grow'>
            <div className='mb-0 h-[18px]'>
              <span className='uppercase text-xs font-bold'> خروج</span>
            </div>
            <div
              className='border-b border-black flex md:min-w-[180px] items-center py-3 cursor-pointer'
              onClick={() => setPickerOpen(true)}
            >
              <input
                readOnly
                type="text"
                className='outline-none grow !border-none !bg-[transparent] !py-0 pointer-events-none !text-lg text-black'
                value={dateValue[1] ? format(dateValue[1], 'yyyy/MM/dd') : ''}
              />
              <span>
                <Iconmoon name='calendar_today' class='text-xl text-silver'></Iconmoon>
              </span>
            </div>
          </div>

          <div className={'text-red self-end ' + (alertDate ? '' : 'hidden')}>
            {alertDate}&nbsp;
          </div>

        </div>

        <div className='relative md:self-center mt-4 md:pr-7 basis-1/4'>
          <button id='main-cta-btn' type="submit" className='!bg-[#d1b178] !border-none text-white py-3 px-4 w-full uppercase text-lg tracking-normal'>
            بررسی اتاق
          </button>
          <div className={(alertDate ? '' : 'hidden')}>
            &nbsp;
          </div>
        </div>
      </div>
    </form>
  );
}

export default AppFa;
